import React, { useState } from 'react'
import CanvasBackground from './CanvasBackground'
import AnimatedText from './AnimatedText'
import Marquee from 'react-fast-marquee'
import iconorange from '../images/icon_orange.svg';

import banner1 from '../images/banner/banner_meroda.png';
import banner2 from '../images/banner/banner_shivook.png';
import banner3 from '../images/banner/donails.png';
import banner4 from '../images/banner/banner_tomo.png';
import banner5 from '../images/banner/banner_bottomless.png';
import banner6 from '../images/banner/Super-Speciosa_1.png';

import ban1 from '../images/banner/banner_meroda_orange.png';
import ban2 from '../images/banner/banner_shivook_orange.png';
import ban3 from '../images/banner/banner_doonails_orange.png';
import ban4 from '../images/banner/banner_tomo_orange.png';
import ban5 from '../images/banner/banner_bottomless_orange.png';
import ban6 from '../images/banner/banner_super_orange.png';
import shopify from '../images/banner/Shopify_logo_svg.png';
import replo from '../images/banner/replo2.png';

const FirstSection = () => {
    const [handlebooking, sethandlebooking] = useState(0);
    const handleScroll = (elementId) => {

        const element = document.getElementById(elementId);

        if (element) {
            // Calculate the header height or default to 80 if header isn't found
            const header = document.querySelector('.header');
            const offset = header ? header.offsetHeight : 80;

            // Get the element's position relative to the viewport
            const elementPosition = element.getBoundingClientRect().top;

            // Check for mobile view (e.g., screen width <= 768px) and adjust scroll behavior
            if (window.innerWidth <= 768) {
                // For mobile, scroll to the element just below the header
                const offsetPosition = elementPosition + window.pageYOffset - 100;

                // Scroll smoothly to the calculated position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            } else {
                // For desktop, keep the default behavior (scrolling to the element with an offset)
                const offsetPosition = elementPosition + window.pageYOffset - offset;

                // Scroll smoothly to the calculated position
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        }
    };
    return (
        <div>
            <section id="first" className='animated-sections'>
                <CanvasBackground />
                <div className='shadowbox'>

                </div>
                <div className='container-xxl first-container'>
                    <div className='row'>
                        <div className='box'>
                            <div className='text-box' data-aos="fade-up" data-aos-once="true" data-aos-duration="800">
                                <img id="iconimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                                <p>For Brands doing over $50k month</p>
                            </div>
                            <AnimatedText />

                            <p className='para' data-aos="fade-up" data-aos-once="true"

                            >DesignLanders helps e-commerce brands increase revenue by optimizing Shopify stores and creating high-converting landing pages.</p>
                            <div className='btnbox'>
                                <button className={handlebooking === 0 ? "btn btn1 b1" : "btn btn1"} onClick={() => sethandlebooking(0)}>
                                    <a
                                        href='https://calendly.com/sudhanshubatra-designer/quick-meeting'
                                        rel="noreferrer"
                                        target='_blank'
                                        className='btnp'> Book Free Consultation</a>

                                </button>
                                <button className={handlebooking === 1 ? "btn btn2 b1" : "btn btn2"} onClick={() => { sethandlebooking(1); handleScroll('review') }}>
                                    <p className='btnp'>See Reviews</p>
                                </button>
                            </div>

                        </div>
                        <div className='col-md-9 box-banner'>
                            <div className='row banner-row align-items-center'>
                                <div className='col-md-6 first'>
                                    <Marquee speed={15} direction="right" className='marquee'>
                                        <div className='boxx'>
                                            <img alt='banner1' src={banner1} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='banner2' src={banner2} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='banner3' src={banner3} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='banner4' src={banner4} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='banner5' src={banner5} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='banner6' src={banner6} className='img-fluid' style={{ height: "40px" }} />
                                        </div>
                                    </Marquee>
                                </div>
                                <div className='middle'>
                                    <div className='imgbox'>
                                        <img alt='shopify' src={shopify} className='img-fluid' />
                                    </div>
                                    <p>&</p>
                                    <div className='imgbox'>
                                        <img alt='replo' src={replo} className='img-fluid' style={{ marginTop: "8px" }} />
                                    </div>
                                </div>
                                <div className='col-md-6 first secondbanner'>
                                    <Marquee speed={15} direction="right" className='marquee'>

                                        <div className='boxx'>
                                            <img alt='ban2' src={ban2} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='ban3' src={ban3} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='ban4' src={ban4} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='ban5' src={ban5} className='img-fluid' />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='ban6' src={ban6} className='img-fluid' style={{ height: "40px" }} />
                                        </div>
                                        <div className='boxx'>
                                            <img alt='ban1' src={ban1} className='img-fluid' />
                                        </div>
                                    </Marquee>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default FirstSection